import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHasFix = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 12,
	viewBox: "0 0 11 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.2233 2.40303C10.2166 2.39098 10.2073 2.37892 10.1965 2.36955C10.1296 2.30258 10.0211 2.30258 9.95413 2.36955L7.64654 4.67714L6.73716 3.76776L9.04609 1.45883C9.0568 1.44812 9.06484 1.43741 9.07288 1.42535C9.12109 1.34366 9.0943 1.23919 9.01261 1.19098C7.69743 0.414191 5.97511 0.592316 4.84341 1.72267C3.94609 2.61999 3.64877 3.89232 3.95279 5.03607L0.0286787 8.96017C-0.0114999 9.00035 -0.00882138 9.06598 0.0326965 9.1075L2.30546 11.3803C2.34698 11.4218 2.41395 11.4245 2.45279 11.3843L6.37555 7.46151C7.52064 7.76687 8.79296 7.47089 9.69163 6.57223C10.822 5.44053 11.0001 3.71821 10.2233 2.40303ZM9.00993 5.88919C8.2318 6.66732 7.06395 6.81732 6.13582 6.33919L6.01796 6.45705L6.01663 6.45571L2.34698 10.1267L1.28627 9.06598L4.36796 5.98428C4.36796 5.98428 4.36796 5.98562 4.3693 5.98562L5.07645 5.27848C4.59832 4.35035 4.74832 3.18249 5.52645 2.40437C5.77741 2.15318 6.07963 1.95913 6.41247 1.83547C6.74532 1.71181 7.10093 1.66146 7.45502 1.68785L5.67511 3.46642C5.59471 3.54691 5.54956 3.65601 5.54956 3.76977C5.54956 3.88353 5.59471 3.99264 5.67511 4.07312L7.34252 5.74053C7.423 5.82092 7.53211 5.86608 7.64587 5.86608C7.75962 5.86608 7.86873 5.82092 7.94921 5.74053L9.72779 3.96196C9.77734 4.65571 9.53493 5.36553 9.00993 5.88919Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgHasFix);
export { ForwardRef as ReactComponent };
